import spacetime from 'spacetime'

export const getTimestamp = (time: number) => {
  const currentYear = spacetime.now().format('year')
  const timeYear = spacetime(time).format('year')
  const showYear = currentYear > timeYear
  const dateFormat = showYear ? 'date' : 'date-ordinal'

  if (spacetime(time).isSame(spacetime.now(), 'date')) {
    return 'Today'
  } else if (spacetime(time).isSame(spacetime.now().subtract(1, 'day'), 'date')) {
    return 'Yesterday'
  }

  return `${spacetime(time).format('day')}, ${spacetime(time).format('month')} ${spacetime(
    time
  ).format(dateFormat)}${showYear ? `, ${timeYear} ` : ''}`
}

const dateNameToAbbriviation = (date: string): string => {
  if (date.includes('second')) {
    return 's'
  } else if (date.includes('minute')) {
    return 'm'
  } else if (date.includes('hour')) {
    return 'h'
  } else if (date.includes('day')) {
    return 'd'
  } else if (date.includes('month')) {
    return 'mo'
  } else if (date.includes('year')) {
    return 'y'
  } else {
    return ''
  }
}

export const timeSinceUpdated = (updatedAt: number): string => {
  const lastUpdated = spacetime(updatedAt)
  const diff = spacetime.now().since(lastUpdated)
  const diffParts = diff.rounded.split(' ')

  if (diffParts.length > 2) {
    return `${diff.rounded.split(' ')[0]}${dateNameToAbbriviation(diff.rounded.split(' ')[1])}`
  } else if (diffParts.length === 1) {
    return diffParts[0]
  } else {
    return ''
  }
}

export const timeSinceUpdatedLongForm = (updatedAt: number): string => {
  const lastUpdated = spacetime(updatedAt)
  const diff = spacetime.now().since(lastUpdated)
  return diff.rounded
}

export const epochToFormattedTimestampFull = (epoch: number): string => {
  return spacetime(epoch).format('{nice-full}')
}

export const minutesSince = (time: number): number => {
  const previousTime = spacetime(time)
  const { diff } = spacetime.now().since(previousTime)
  return diff.minutes
}
